import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HeaderComponent } from '../../ui/header/header.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-minimal-shell',
  templateUrl: './minimal-shell.component.html',
  styleUrls: ['./minimal-shell.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule, HeaderComponent],
})
export class MinimalShellComponent {}
